<template>
  <div class="ShareButton"> 
    <div class="Button white" :class="{ 'disable' : listen }" @click="onClick()">{{ trans('GLOBAL.share_button') }}</div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'ShareButton',
  data: ()=>({
    listen: false
  }),
  computed: {
    add_listen() { return this.$store.getters['app/add_listen'] }
  },
  watch: {
    add_listen(nw) {
      this.listen = nw
      // console.log(this.listen);
    },
  },
  mounted() {
    // console.log('ShareButton ! ');
  },
  methods:{
    onClick() {
      this.$router.push({ params: { step: 'share' } })
    }, 
  }

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.ShareButton  
  position relative
  width 100%
  display flex
  justify-content center

</style>


